import React from "react";
// Components
import GenericTable from "./GenericTable";

// *******************************
// Tabla que renderiza componentes
// Params:
// *headers             => Cabeceras de la tabla formada por un array de objetos con dos campos
//  {
//    name                => Nombre de la cabecera (puede ser un componente o un string)
//    value               => Si es función se ejecutará sobre la row, sino se mostrará accediendo a la key de la row.
//  }
//  rows                => Tuplas de la tabla
//  emptyTableComponent => Componente que se renderizará cuando no haya rows
// *********************************

const ComponentTable = ({ headers = [], rows = [], emptyTableComponent }) => {
  return (
    <GenericTable>
      <thead>
        <tr>
          {headers.map((header) => (
            <th>{header.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length
          ? rows.map((row) => {
              return <tr>{headers.map((header) => (header.value instanceof Function ? <td style={header?.style && header.style}>{header.value(row)}</td> : <td>{row[header.value]}</td>))}</tr>;
            })
          : emptyTableComponent}
      </tbody>
    </GenericTable>
  );
};

export default ComponentTable;
